export const TYPES = {
    COMETD_SUBSCRIBE: 'COMETD/SUBSCRIBE',
    COMETD_UNSUBSCRIBE: 'COMETD/UNSUBSCRIBE',
    COMETD_MESSAGE: 'COMETD/MESSAGE',
    CANCEL: 'COMETD/CANCEL'
};

// Make sure that you record all channel
// names here so we keep them in one place.
export const CHANNELS = {
    JACKPOTS: '/public/jackpotsUpdated',
    LIVE_CASINO_TABLE: '/public/liveCasino/table',
    MUST_DROP_JACKPOTS: '/public/redtiger-jackpots/*',
    REEL_RACES: '/public/tournaments',
    PLAYER: '/player',
    ADVENTURE: '/adventurer',
    SESSION: '/session',
    SESSION_ENDED: '/session/([a-z0-9-]+)/ended',
    CONNECT: '/meta/connect',
    HANDSHAKE: '/meta/handshake',
    UMOBOARDS: '/public/leaderboards/status'
};

export const MESSAGES = {
    DEPOSIT_CONFIRMED: 'depositConfirmed',
    NOTIFICATION_ADDED: 'notificationAdded',
    BALANCE_UPDATED: 'walletBalanceUpdated',
    ENRICHED_DEPOSIT_CONFIRMED: 'enrichedDepositConfirmed',
    REALITY_CHECK_PERIODIC_NOTIFICATION: 'realityCheck',
    GGL_REALITY_CHECK_SESSION_STARTED:
        'com.casumo.playok.realitychecks.api.events.GGLRealityCheckSessionStartedEvent',
    GGL_REALITY_CHECK_BREAK_STARTED:
        'com.casumo.playok.realitychecks.api.events.GGLRealityCheckBreakStartedEvent',
    GGL_REALITY_CHECK_BREAK_ENDED:
        'com.casumo.playok.realitychecks.api.events.GGLRealityCheckBreakEndedEvent',
    MANDATORY_MESSAGE_RECEIVED: 'mandatoryMessageReceived',
    ES_SESSION_STATUS_UPDATED: 'com.casumo.es.slotsessions.notifications.StatsUpdatedNotification',
    ES_SESSION_ENDED: 'com.casumo.es.slotsessions.notifications.SessionEndedNotification',
    ES_SESSION_LIMIT_ALMOST_CONSUMED:
        'com.casumo.es.slotsessions.notifications.LimitAlmostConsumedNotification',
    ES_SESSION_PERIODIC_REMINDER:
        'com.casumo.es.slotsessions.notifications.PeriodicReminderNotification',
    ES_SESSION_TIME_REMAINING: 'com.casumo.es.slotsessions.notifications.TimeRemainingNotification'
} as const;

export const URLS = {
    DEFAULT: '/cometd/'
};

export const DGOJ_END_SESSION_REASONS = Object.freeze({
    LOGGED_OUT: 'LOGGED_OUT',
    LIMIT_REACHED: 'LIMIT_REACHED'
});

export const PERSISTENT_NOTIFICATION_COMETD_KEY =
    'com.casumo.persistent.notifications.service.NotificationPublisher.NotificationCreatedEvent';
